// extracted by mini-css-extract-plugin
export default {"container":"Tooltip_container__3uQMF"};